import React from 'react';
import BypassCard from 'src/components/Cards/BypassCard';
import { LossCardProps } from './LossTypes';
import cardTruck from 'src/assets/truckWarning.png';
import { calculateTotalAmount, getSelectedClaims } from '../../helpers/LossHelpers';

const LossCard: React.FC<LossCardProps> = ({ loss, index, onEdit, onDelete }) => {
  // Handle edit and delete actions
  const handleEdit = () => onEdit(index);
  const handleDelete = () => onDelete(index);

  // Dynamically determine the selected claims
  const selectedClaims = getSelectedClaims(loss);

  return (
    <BypassCard
      testID={`loss-cards-item-${index}`}
      key={index}
      imageSrc={cardTruck}
      imageWidth={75}
      imageHeight={32}
      onEdit={handleEdit}
      onDelete={handleDelete}
      title={calculateTotalAmount(loss)} // Total amount of losses
      description={`${loss.lossYear || 'N/A'} | ${selectedClaims.join(' | ')}`} // Display selected claims
    />
  );
};

export default LossCard;
